"use client";
import React from "react";
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { commentsContents } from "./commentsContents";
import SunIcon from "@/app/icons/sunIcon";
import Image from "next/image";

const CommentSlider = () => {
  return (
    <Swiper
      cssMode={true}
      navigation={true}
      pagination={true}
      mousewheel={true}
      keyboard={true}
      modules={[Navigation, Pagination, Mousewheel, Keyboard]}
      className="h-full CommentSwiper"
    >
      {commentsContents.map((comment) => (
        <SwiperSlide key={comment.id} className="p-4 xs:p-6 xl:p-8">
          <div className="flex flex-col gap-2">
            <SunIcon />
            <p className="!text-xs !leading-6 xl:!text-sm">{comment.comment}</p>
          </div>
          <div className="flex gap-3">
            <div className="flex justify-center items-center w-10 h-10 overflow-hidden rounded-full">
              <Image
                src={comment.image}
                alt={comment.name}
                width={100}
                height={100}
                className="w-full h-full rounded-full"
              />
            </div>
            <div className="flex flex-col justify-center">
              <span className="text-shadow-regal-black-light text-sm font-bold !leading-normal">
                {comment.city}
              </span>
              <span className="text-regal-black-lighter text-xs ">
                {comment.name}
              </span>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default CommentSlider;
